"use client";

import { getSeoPageProperties, page, track } from "@homeinstead/analytics";
import { EventName } from "@homeinstead/shared";
import { usePathname, useSearchParams } from "next/navigation";
import { useCallback, useEffect, useRef } from "react";
import { parseUtmParameters } from "~care/lib/utils/tracking-cookie";
import { URLParamsEvent } from "~care/types/events";

export function Analytics() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const hasTracked = useRef(false);

  const trackParams = useCallback(() => {
    const utmParams = parseUtmParameters(searchParams.toString());

    if (Object.keys(utmParams).length === 0) {
      return;
    }

    track(EventName.URL_PARAMS, URLParamsEvent({ params: utmParams }));

    hasTracked.current = true;
  }, [searchParams]);

  useEffect(() => {
    if (!hasTracked.current) {
      trackParams();
    }

    const currentSearchString = searchParams.toString();

    const seoComplianceProperties = getSeoPageProperties({ pathname });

    page({
      path: pathname,
      search: currentSearchString,
      url:
        typeof window !== "undefined"
          ? `${window.location.origin}${pathname}${
              currentSearchString ? `?${currentSearchString}` : ""
            }`
          : `${pathname}${currentSearchString ? `?${currentSearchString}` : ""}`,
      ...seoComplianceProperties,
    });
  }, [pathname, searchParams, trackParams]);

  return null;
}
